import { CursorPointerIcon } from './CursorPointerIcon';

/**
 * author: Austin Andrews
 * id B5465B23-729A-405E-9155-486A36D8135F
 * name cursor-pointer
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cursor-pointer.svg
 * tags
 */
export const CursorHandIcon = CursorPointerIcon;
export default CursorHandIcon